import { useState } from "react";
import { ChevronDown, ChevronRight, Database } from "lucide-react";

const RemainingFuel = () => {
  const [openSections, setOpenSections] = useState(false);

  const toggleSection = () => {
    setOpenSections((prev) => !prev);
  };

  const fuelRemainingMetrics = [
    {
      id: "hfo",
      title: "Heavy Fuel Oil (HFO)",
      description: "Remaining Heavy Fuel Oil on board",
      calculation: "Latest robmthfo field value from vessel performance data",
      field: "robmthfo",
      output: "Current HFO remaining in metric tons",
      borderColor: "border-amber-200",
      bgColor: "bg-amber-50",
      textColor: "text-amber-700",
    },
    {
      id: "lfo",
      title: "Light Fuel Oil (LFO)",
      description: "Remaining Light Fuel Oil on board",
      calculation: "Latest robmtlfo field value from vessel performance data",
      field: "robmtlfo",
      output: "Current LFO remaining in metric tons",
      borderColor: "border-orange-200",
      bgColor: "bg-orange-50",
      textColor: "text-orange-700",
    },
    {
      id: "mgo",
      title: "Marine Gas Oil (MGO)",
      description: "Remaining Marine Gas Oil on board",
      calculation: "Latest robmtmgo field value from vessel performance data",
      field: "robmtmgo",
      output: "Current MGO remaining in metric tons",
      borderColor: "border-blue-200",
      bgColor: "bg-blue-50",
      textColor: "text-blue-700",
    },
    {
      id: "others",
      title: "Other Fuel Types",
      description: "Remaining other fuel types on board",
      calculation: "Latest robmtothers field value from vessel performance data",
      field: "robmtothers",
      output: "Current other fuels remaining in metric tons",
      borderColor: "border-gray-200",
      bgColor: "bg-gray-50",
      textColor: "text-gray-700",
    }
  ];

  return (
    <div>
      <div className="mb-6 border border-gray-300 rounded-lg overflow-hidden">
        <button
          className="flex items-center justify-between w-full p-5 bg-gray-50 hover:bg-gray-100 transition-colors"
          onClick={toggleSection}
        >
          <div className="flex items-center gap-4">
            <div className="p-3 bg-[#cde7f7] rounded-lg">
              <Database className="w-6 h-6 text-[#1a5276]" />
            </div>
            <div className="text-left">
              <h2 className="text-md font-bold text-gray-800">
                Fuel Remaining Analysis (ROB)
              </h2>
              <p className="text-gray-600 text-sm">
                Latest ROB (Remaining On Board) values using MongoDB aggregation
              </p>
            </div>
          </div>
          {openSections ? (
            <ChevronDown className="w-5 h-5 text-gray-500" />
          ) : (
            <ChevronRight className="w-5 h-5 text-gray-500" />
          )}
        </button>

        {openSections && (
          <div className="p-5 bg-white border-t border-gray-200">
            {/* ROB Metrics */}
            <div className="mb-6">
              <h4 className="font-semibold text-gray-800 mb-3">ROB Database Fields</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {fuelRemainingMetrics.map((metric) => (
                  <div
                    key={metric.id}
                    className={`p-5 rounded-lg border ${metric.borderColor} ${metric.bgColor}`}
                  >
                    <div className="flex justify-between items-start mb-3">
                      <h4 className="font-semibold text-gray-800">
                        {metric.title}
                      </h4>
                      <span className={`text-xs font-medium px-2 py-1 rounded ${metric.textColor} ${metric.bgColor.replace('50', '100')}`}>
                        Field: {metric.field}
                      </span>
                    </div>

                    <div className="mb-3">
                      <p className="text-sm font-medium text-gray-700 mb-1">Description:</p>
                      <p className="text-sm text-gray-600">{metric.description}</p>
                    </div>

                    <div className="mb-3">
                      <p className="text-sm font-medium text-gray-700 mb-1">Database Query:</p>
                      <div className="text-sm text-gray-600 bg-white p-2 rounded border font-mono">
                        $ifNull: ["${metric.field}", 0]
                      </div>
                    </div>

                    <div className="mb-3">
                      <p className="text-sm font-medium text-gray-700 mb-1">Data Source:</p>
                      <p className="text-sm text-gray-600">
                        Latest record from <code className="text-xs bg-gray-100 px-1 rounded">VesselPerformance</code> collection
                      </p>
                    </div>

                    <div>
                      <p className="text-sm font-medium text-gray-700 mb-1">Output:</p>
                      <p className={`text-sm font-semibold ${metric.textColor}`}>
                        {metric.output}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RemainingFuel;